// extracted by mini-css-extract-plugin
export default {"wrapper":"LandscapeIndicatorVerificationApproachPage_wrapper__j4Czb"};